import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useHistory } from "react-router-dom";
import axios from "axios";
import "../styles/components/footer.scss";
import "../styles/components/recherche.scss";

const Header = () => {
	/*---partie recherche---*/
	const [data, setData] = useState([]);
	const [query, setQuery] = useState("");
	const [searching, setSearching] = useState(false);
	const history = useHistory();

	const closeSearch = useCallback(() => {
		setQuery("");
		setData([]);
	}, []);

	const handleClick = (id) => {
		closeSearch();
		history.push(`/movieDetails/${id}`);
	};

	useEffect(() => {
		if (!query) {
			setData([]);
			return;
		}
		setSearching(true);
		axios
			.get(
				`https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=fr-FR&query=${query}`
			)
			.then((res) => setData(res.data.results))
			.catch((error) => console.error(error))
			.finally(() => setSearching(false));
	}, [query]);

	useEffect(() => {
		if (!query) return;
		const onKeyDown = (e) => {
			if (e.key === "Escape") closeSearch();
		};
		document.addEventListener("keydown", onKeyDown);
		return () => document.removeEventListener("keydown", onKeyDown);
	}, [query, closeSearch]);

	const onSearch = (e) => {
		setQuery(e.target.value);
	};
	/*----------------*/

	const [isMenuOpen, setMenuOpen] = useState(false);

	const toggleMenu = () => {
		setMenuOpen((prev) => !prev);
	};

	return (
		<header>
			<div className="nav-bar-fim">
				<div className="container_recherche">
					<input
						type="text"
						placeholder="Recherche..."
						value={query}
						onChange={onSearch}
					/>
					{query && (
						<div className="recherche-overlay" onClick={closeSearch}>
							<div
								className="recherche-body"
								onClick={(e) => e.stopPropagation()}>
								<button
									type="button"
									className="recherche-close"
									aria-label="Fermer la recherche"
									onClick={closeSearch}>
									×
								</button>
								{searching ? (
									<p className="recherche-empty">Recherche…</p>
								) : data.length > 0 ? (
									<div className="row">
										{data.map((m) => (
											<div
												className="d-flex justify-content-center col-md-12 col-lg-6"
												key={m.id}>
												<div
													className="container row"
													onClick={() => handleClick(m.id)}
													style={{ cursor: "pointer" }}>
													<div className="d-flex justify-content-center col-md-12 col-xl-4">
														<img
															src={`https://image.tmdb.org/t/p/w500${m.poster_path}`}
															alt={m.title}
														/>
													</div>
													<div className="detail-recherche d-flex align-items-center col-md-12 col-xl-8">
														<div className="titreDate d-flex flex-wrap">
															<h3>{m.title}</h3>
															<span>{m.release_date}</span>
														</div>
														<p>{m.overview}</p>
													</div>
												</div>
											</div>
										))}
									</div>
								) : (
									<p className="recherche-empty">
										Aucun résultat pour « {query} »
									</p>
								)}
							</div>
						</div>
					)}
					<div className="search">
						<img src="/search.png" alt="Search" />
					</div>
				</div>
				<div id="menu" className={isMenuOpen ? "overlay" : ""}>
					<ul>
						<li>
							<NavLink exact to="/" activeClassName="nav-active">
								Accueil
							</NavLink>
						</li>
						<li>
							<NavLink exact to="/categories" activeClassName="nav-active">
								Catégories
							</NavLink>
						</li>
						<li>
							<NavLink exact to="/APropos" activeClassName="nav-active">
								À Propos
							</NavLink>
						</li>
					</ul>
				</div>
				<div className="menu">
					<div
						id="burger-menu"
						className={isMenuOpen ? "close" : ""}
						onClick={toggleMenu}>
						<span></span>
					</div>
				</div>
			</div>
			<div className="logo-fim-header">
				<NavLink exact to="/" activeClassName="nav-active">
					<img src="/logo-fim.png" alt="logo-FIM" />
				</NavLink>
			</div>
		</header>
	);
};

export default Header;
